<template lang='pug'>
div(class='event')
  div(class='event-time')
    | {{ event.start.format('HH:mm') }} -
    | {{ event.end.format('HH:mm') }}
</template>

<script>
export default {
  props: ['event']
}
</script>

<style scoped>
.event-time {
  font-size: 12px;
}
</style>
